export default "__VITE_ASSET__98955769__"